import React from "react";

const GetPriceButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="w-[200px] bg-blue-500 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded">
      Get Home Price
    </button>
  );
};

export default GetPriceButton;
